module.exports = __webpack_public_path__ + "static/media/shopping-bag.cefd3642.svg";